import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const ignoredUrl: Array<string> = ['/auth/login'];
  const token = authService.getAuthToken()?.access_token;

  if (token) {
    if (ignoredUrl.includes(state.url)) {
      router.navigate(['/']);
      return false;
    }
    return true;
  }
  if (!token && state.url !== '/auth/login') {
    router.navigate(['/auth/login']);
    return false;
  }

  return true;
};
